export default "__VITE_ASSET__USVJOFvD__"